<template>
	<div class="w-full px-4">
		<div
			v-if="permission"
			class="w-full"
		>
			<div class="w-full">
				<p class="text-center">
					VOCÊ PODE CONVIDAR OUTROS PROFISSIONAIS QUE UTILIZEM O
					INSTANT PARA FAZER PARTE DESTA ORGANIZAÇÃO.
				</p>
			</div>
			<div class="flex items-center mb-4">
				<div class="w-full mr-3">
					<div class="form-group mb-0">
						<input
							ref="invite_document"
							v-model="$v.invite_document.$model"
							v-mask="['###.###.###-##']"
							type="tel"
							class="form-control"
							:class="{ 'is-invalid': $v.invite_document.$error }"
							placeholder="Convidar profissionais do Instant por CPF"
						/>
						<div
							v-if="!$v.invite_document.required"
							class="invalid-feedback"
						>
							Obrigatório
						</div>
						<div
							v-else-if="!$v.invite_document.CPFValidation"
							class="invalid-feedback"
						>
							CPF Invalido
						</div>
					</div>
				</div>
				<div class="pl-md-0">
					<button
						class="btn btn-primary btn-block px-5"
						@click="SearchDocNumber"
					>
						CONVIDAR
					</button>
				</div>
			</div>
		</div>
		<template v-if="providers.length > 0">
			<div
				v-for="provider in filtered_providers"
				:key="provider.id"
				class="border mb-2 p-4 mt-3 rounded-lg"
			>
				<div class="row justify-content-between align-items-center">
					<div class="col">
						<span
							class="status-indicator"
							:class="{ online: provider.online }"
						>
							{{ provider.provider.name.toUpperCase() }}
						</span>

						<small class="d-block opacity-50 mt-3 mt-md-0">
							Template:
							{{ provider.workgroup_schema.toUpperCase() }}
						</small>
						<div v-html="GenerateProfiles(provider.provider)" />
					</div>
					<div class="col-12 col-md-auto my-3 my-md-0">
						<div class="d-flex justify-content-between"></div>
					</div>
					<div class="col-12 col-md-auto">
						<div class="d-flex justify-content-between">
							<button
								v-if="permission"
								class="btn btn-warning btn-sm px-3 mr-3"
								:disabled="!provider.online"
								@click="
									ForceLogout(provider.account_provider_id)
								"
							>
								DESCONECTAR
							</button>
							<button
								v-if="permission"
								class="btn btn-primary btn-sm px-3 mr-3"
								@click="OpenPermissions(provider.provider)"
							>
								PERMISSÕES
							</button>
							<button
								v-if="permission"
								class="btn btn-danger btn-sm px-3"
							>
								<i class="far fa-ban"></i>
							</button>
						</div>
					</div>
				</div>
			</div>
			<div
				id="modal-profiles"
				class="modal fade"
			>
				<div class="modal-dialog modal-dialog-centered">
					<div class="modal-content">
						<div class="modal-header px-5 py-4">
							<h4 class="font-20 m-0">
								{{ !invite_account ? 'Gerenciar' : 'Definir' }}
								permissões
							</h4>
						</div>
						<div class="modal-body">
							<div
								v-if="selected_provider || invite_account"
								class="row p-4"
							>
								<div class="col-12">
									<h5 class="text-center">
										{{
											selected_provider
												? selected_provider.name
												: invite_account.name
										}}
									</h5>
								</div>
								<div
									v-for="profile in profiles"
									:key="profile.id"
									class="col-12"
								>
									<div
										class="border rounded-lg py-3 px-4 mt-3"
									>
										<div class="form-row flex-nowrap">
											<div class="col-9">
												{{ profile.name }}
											</div>
											<div class="col-3">
												<div
													class="d-inline-block form-group mr-4 mb-0 form-check"
												>
													<input
														:id="`switch${profile.id}`"
														v-model="
															selected_profiles
														"
														type="checkbox"
														:checked="
															HasThisProfile(
																profile
															)
														"
														:value="profile.id"
													/>
													<label
														:for="`switch${profile.id}`"
													>
														{{
															HasThisProfile(
																profile
															)
																? 'ATIVO'
																: 'INATIVO'
														}}
													</label>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="d-flex justify-content-between p-4">
								<button
									type="button"
									class="btn btn-light p-3 px-4"
									@click="CloseModal('profiles')"
								>
									cancelar
								</button>
								<button
									type="button"
									class="btn btn-primary p-3 px-4"
									@click="
										!invite_account
											? SavePermission()
											: SetPermissions()
									"
								>
									salvar
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	import { required } from 'vuelidate/lib/validators'
	import Helpers from '../../../helpers'
	import moment from 'moment'
	const helpers = new Helpers()

	const _ = require('lodash')

	import Swal from 'sweetalert2'
	import { mapActions, mapGetters } from 'vuex'
	const CPFValidation = (value, vm) => helpers.ValidaCPF(value)
	export default {
		name: 'Employees',
		props: {
			providers: {
				type: Array,
				default: () => [],
			},
			subscription: {
				type: Object,
				default: () => {},
			},
			organization_id: {
				type: [String, Number],
				default: null,
			},
			permission: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				invite_document: '',
				invite_account: null,
				selected_provider: null,
				profiles: [],
				selected_profiles: [],
				max_quantity: 6,
				quantity: 1,
				product: null,
				price: null,
				all_cards: [],
			}
		},
		validations: {
			invite_document: {
				required,
				CPFValidation,
			},
		},
		computed: {
			...mapGetters('auth', ['online_accounts', 'cards']),
			filtered_providers() {
				let providers = this.providers.map(p => {
					p.online = false

					let find_account = this.online_accounts.find(
						oa => oa.id == p.account_provider_id
					)

					if (find_account) {
						p.online = true
					}

					return p
				})

				providers = _.orderBy(providers, 'provider.name', 'asc')

				return providers.sort(x => (x.online ? -1 : 1))
			},
			price_per_user() {
				if (this.price && this.price.unit_amount) {
					return `${this.price.unit_amount / 100}`.replace('.', ',')
				}

				return '0,00'
			},
			price_total() {
				if (this.price && this.price.unit_amount) {
					return `${
						(this.price.unit_amount / 100) * this.quantity
					}`.replace('.', ',')
				}

				return '0,00'
			},
			default_payment() {
				return this.cards.find(c => c.default) || null
			},
			parsed_expire_date() {
				if (this.subscription.billing_cycle_anchor) {
					return moment
						.unix(this.subscription.billing_cycle_anchor)
						.format('DD/MM/YYYY')
				}

				return moment().format('DD/MM/YYYY')
			},
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			...mapActions('auth', ['GetAuthAccount']),
			AddMaxQuantity() {
				this.quantity += 1
			},
			RemMaxQuantity() {
				this.quantity -= 1
			},
			GetProduct() {
				const vm = this

				vm.StartLoading()

				return window.api
					.call('post', '/gateway/get-product', {
						product_id: 1,
					})
					.then(({ data }) => {
						if (data.response) {
							vm.product = data.product
							vm.price = data.price
						}
					})
					.finally(() => {
						vm.FinishLoading()
					})
			},
			GetBrand(brand) {
				const item = this.all_cards.find(
					e => e.name === brand.toLowerCase()
				)

				if (item) {
					const finalBrand = require(`@/assets/svg/brands/${item.svg}.svg`)

					return finalBrand
				}

				return false
			},
			GenerateProfiles(data) {
				const profiles = data.provider_profiles
				let html = ''

				if (profiles.length > 0) {
					for (let i in profiles) {
						if (
							profiles[i].account_requester_id ===
							parseInt(this.organization_id)
						) {
							html += `<span class="badge badge-light mr-3">${profiles[
								i
							].profile.name.toUpperCase()}</span>`
						}
					}
				}
				return html
			},
			ForceLogout(account_id) {
				this.StartLoading()

				return window.api
					.call('post', '/force-logout', {
						account_id: account_id,
					})
					.then(({ data }) => {
						if (data.response) {
							Swal.fire({
								title: 'Usuário deslogado com sucesso.',
								toast: true,
								timer: 3000,
								position: 'top',
								icon: 'success',
							})
						} else {
							Swal.fire({
								title: 'Eita!',
								text: 'Houve um erro ao deslogar este usuário, contate o suporte.',
								icon: 'error',
							})
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			LoadProfiles() {
				this.StartLoading()

				return window.api
					.call('post', '/get-profiles', {
						account_id: this.organization_id,
					})
					.then(({ data }) => {
						if (data.response) {
							this.profiles = data.profiles
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			SearchDocNumber() {
				const vm = this
				vm.$v.invite_document.$touch()

				if (!vm.$v.invite_document.$invalid) {
					this.StartLoading()

					window.api
						.call('post', '/verify-provider', {
							document_number: vm.invite_document,
							account_requester_id: vm.organization_id,
						})
						.then(async ({ data }) => {
							if (data.response) {
								vm.invite_account = data.account

								await Swal.fire({
									title: 'Confirmar convite',
									text: `Deseja convidar ${vm.invite_account.name} a fazer parte desta organização?`,
									icon: 'info',
									showCancelButton: true,
									confirmButtonColor: '#009e92',
									cancelButtonColor: '#d33',
									confirmButtonText: 'Enviar',
									cancelButtonText: 'Cancelar',
									showLoaderOnConfirm: true,
									allowOutsideClick: () => !Swal.isLoading(),
								}).then(result => {
									if (result.isConfirmed) {
										vm.OpenModal('profiles')
									} else {
										vm.invite_account = null
									}
								})
							} else {
								Swal.fire({
									title: 'Opss...',
									text: 'Este CPF não possui conta no Instant ou já esta cadastrado nesta organização.',
									icon: 'error',
								})
							}
						})
						.finally(() => {
							this.FinishLoading()
						})
				} else {
					window.helpers.focusInvalid(this.$v.invite_document, this)
				}
			},
			HasThisProfile(profile) {
				const has = this.selected_profiles.find(sp => sp == profile.id)

				return has ? true : false
			},
			async OpenPermissions(provider) {
				this.selected_profiles = []

				if (
					provider.provider_profiles &&
					provider.provider_profiles.length > 0
				) {
					provider.provider_profiles.forEach(profile => {
						if (
							profile.account_requester_id ===
							parseInt(this.organization_id)
						) {
							this.selected_profiles.push(profile.profile_id)
						}
					})
				}

				await this.LoadProfiles()

				this.selected_provider = provider

				window.jQuery('#modal-profiles').modal('show')
			},
			SavePermission() {
				this.StartLoading()

				return window.api
					.call('post', '/manage-employee-profiles', {
						provider_id: this.selected_provider.id,
						account_id: this.organization_id,
						profiles: this.selected_profiles,
					})
					.then(async ({ data }) => {
						if (data.response) {
							Swal.fire({
								icon: 'success',
								title: 'Perfis do usuário alterados com sucesso',
								toast: true,
								position: 'top',
								timer: 3000,
								timerProgressBar: true,
							})

							await this.GetAuthAccount()
							this.$emit('refresh')
							this.CloseModal('profiles')
						} else {
							Swal.fire({
								icon: 'error',
								title: 'Opss...',
								text: 'Houve um erro ao concluir, contate o suporte',
							})
						}
					})
					.finally(() => {
						this.FinishLoading()

						window.jQuery('#modal-profiles').modal('hide')
					})
			},
			async SetPermissions() {
				const vm = this

				vm.StartLoading()

				return window.api
					.call('post', '/new-workgroup', {
						account_provider_id: this.invite_account.id,
						account_requester_id: this.organization_id,
					})
					.then(async ({ data }) => {
						if (data.response) {
							vm.selected_provider = data.workgroup.provider

							window.api
								.call('post', '/manage-employee-profiles', {
									provider_id:
										data.workgroup.account_provider_id,
									account_id:
										data.workgroup.account_requester_id,
									profiles: vm.selected_profiles,
								})
								.then(async ({ data }) => {
									if (data.response) {
										Swal.fire({
											title: 'Convite enviado com sucesso',
											text: 'Solicite o aceite deste ao colaborador.',
											icon: 'success',
										})

										await this.GetAuthAccount()
										this.$emit('refresh')
									} else {
										Swal.fire({
											icon: 'error',
											title: 'Opss...',
											text: 'Houve um erro ao concluir, contate o suporte',
										})
									}

									vm.selected_provider = null
									vm.selected_profiles = []
									vm.invite_account = null

									window
										.jQuery('#modal-profiles')
										.modal('hide')
								})

							vm.$emit('new', data.workgroup)
						}

						return data
					})
					.finally(() => {
						vm.FinishLoading()
					})
			},
			async OpenModal(id) {
				if (id == 'profiles') {
					await this.LoadProfiles()
				}

				window.jQuery(`#modal-${id}`).modal('show')
			},
			CloseModal(id) {
				if (id === 'profiles') {
					this.selected_profiles = []
					this.selected_provider = null
					this.invite_account = null
				}

				window.jQuery(`#modal-${id}`).modal('hide')
			},
		},
		beforeMount() {
			this.all_cards = window.creditCards

			this.GetProduct()
		},
	}
</script>

<style lang="css" scoped>
	.modal-add-users .modal-dialog {
		max-width: 600px !important;
	}
	.status-indicator {
		margin: 0 20px;
		font-size: 16px;
		font-weight: 500;
		text-transform: uppercase;
		align-self: center;
	}

	.status-indicator:before {
		content: '';
		border: 1px solid #8e8e8e;
		background-color: #8e8e8e;
		position: absolute;
		width: 15px;
		height: 15px;
		top: 5px;
		left: 15px;
		border-radius: 50%;
	}

	.status-indicator.online:before {
		border-color: #20c964;
		background-color: #20c964;
		box-shadow: 0px 0px 7px 2px #20c964;
	}

	.financial-card {
		height: 100px;
	}

	.financial-card .plus {
		height: 60px;
		width: 60px;
		border-radius: 50%;
	}

	.card-plan {
		background-color: var(--dark-light);
		max-width: unset;
		min-width: unset;
		border-radius: 5px;
	}

	.quantity-container input {
		height: 45px;
	}

	.quantity-container button {
		height: 30px;
		width: 40px;
		padding: 0rem 0.48rem;
	}

	#modal-add-users a {
		color: var(--primary);
		cursor: pointer;
		font-weight: 700;
	}

	.credit-card-brand img {
		width: 40px;
	}
</style>
